// src/PieChart.js
import React, { useEffect, useState } from "react";
import { Pie } from "react-chartjs-2";
import axios from "axios";
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
  LinearScale,
} from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { getToken, base_url } from "../../config/config";

ChartJS.register(ArcElement, Tooltip, Legend, ChartDataLabels, LinearScale);

const PieChart = () => {
  const [data, setData] = useState({});
  const [startdate, setStartDate] = useState("2024-05-14"); // Default date value
  const [enddate, setEndDate] = useState("2024-05-14"); // Default date value

  useEffect(() => {
    if (enddate) {
      const fetchData = async () => {
        try {
          const response = await axios.post(
            `${base_url}/v1/calculatePercentage`,
            {
              startDate: startdate,
              endDate: enddate,
            },
          );
          setData(response.data);
        } catch (error) {
          console.error("Error fetching data:", error);
        }
      };

      fetchData();
    }
  }, [enddate]);

  const generateChartData = (anrData) => {
    const labels = Object.keys(anrData).filter(
      (key) => key !== "totalPercentage",
    );
    const percentages = labels.map((label) =>
      parseFloat(anrData[label].percentage.replace("%", "")),
    );

    return {
      labels,
      datasets: [
        {
          data: percentages,
          backgroundColor: [
            "#FF6384",
            "#36A2EB",
            "#FFCE56",
            "#FF9F40",
            "#4BC0C0",
            "#9966FF",
            "#FF6384",
            "#36A2EB",
            "#FFCE56",
            "#FF9F40",
            "#4BC0C0",
            "#9966FF",
          ],
          hoverBackgroundColor: [
            "#FF6384",
            "#36A2EB",
            "#FFCE56",
            "#FF9F40",
            "#4BC0C0",
            "#9966FF",
            "#FF6384",
            "#36A2EB",
            "#FFCE56",
            "#FF9F40",
            "#4BC0C0",
            "#9966FF",
          ],
        },
      ],
    };
  };

  const options = {
    plugins: {
      tooltip: {
        callbacks: {
          label: function (context) {
            let label = context.label || "";
            if (label) {
              label += ": ";
            }
            label += context.raw + "%";
            return label;
          },
        },
      },
      datalabels: {
        display: true,
        formatter: (value) => {
          return value.toFixed(2) + "%";
        },
        color: "#fff",
        font: {
          weight: "bold",
          size: 14,
        },
      },
    },
  };

  return (
    <div>
      <h2>Percentage Distribution</h2>
      <div>
        <label htmlFor='date'>Start Date: </label>
        <input
          type='date'
          id='date'
          value={startdate}
          onChange={(e) => setStartDate(e.target.value)}
        />
      </div>
      <div>
        <label htmlFor='date'>End Date: </label>
        <input
          type='date'
          id='date'
          value={enddate}
          onChange={(e) => setEndDate(e.target.value)}
        />
      </div>
      <div style={{ display: "flex", flexWrap: "wrap" }}>
        {Object.keys(data).length > 0 ? (
          Object.keys(data).map((name, index) => (
            <div key={index} style={{ width: "45%", margin: "2.5%" }}>
              <h3>{name}</h3>
              <Pie data={generateChartData(data[name])} options={options} />
            </div>
          ))
        ) : (
          <p>Loading...</p>
        )}
      </div>
    </div>
  );
};

export default PieChart;
